'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondsBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/secondsBefore.js
// module id = 210
// module chunks = 0